import { render, staticRenderFns } from "./bookdentist.vue?vue&type=template&id=c74061a8&scoped=true&"
import script from "./bookdentist.vue?vue&type=script&lang=js&"
export * from "./bookdentist.vue?vue&type=script&lang=js&"
import style0 from "./bookdentist.vue?vue&type=style&index=0&id=c74061a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74061a8",
  null
  
)

export default component.exports